export function getItemFromLocalStorage(key) {
    const item = localStorage.getItem(key);
    if (!item) {
        return null;
    }
    return JSON.parse(item);
}
export function setItemInLocalStorage(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
export function getDatatableColumnConfig(configKey, columnName) {
    let config = getItemFromLocalStorage(configKey);
    if (config != null) {
        return config['columns'].find((column) => column.name == columnName);
    }
    return null;
}
export function getDatatableConfig(configKey, settingKey) {
    let config = getItemFromLocalStorage(configKey);
    if (config != null) {
        return config[settingKey];
    }
    return null;
}
